import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import styles from './Settings.module.sass';
import Dropdown from '../../../components/Dropdown';
import { getCities, getRankingList } from '@core';

const options = ['All', 'Male', 'Female'];

interface SettingsProps {
  changeFilters: (filters: { gender: string | null; city: string | null; ranking: string | null }) => void;
}

const Settings = ({ changeFilters }: SettingsProps) => {
  const [filterByGender, setFilterByGender] = useState('All');
  const [filteredByCity, setFilteredByCity] = useState('All');
  const [filteredByRanking, setFilteredByRanking] = useState('All');
  const [cities, setCities] = useState([]);
  const [rankings, setRankings] = useState([]);

  const handleFilter = () => {
    changeFilters({
      gender: filterByGender === 'All' ? null : filterByGender,
      city: filteredByCity === 'All' ? null : filteredByCity,
      ranking: filteredByRanking === 'All' ? null : filteredByRanking,
    });
  };

  const reset = () => {
    setFilteredByCity('All');
    setFilterByGender('All');
    setFilteredByRanking('All');
    handleFilter();
  };

  useEffect(() => {
    const fetchCities = async () => {
      // Simulate fetching cities from an API
      const fetchedCities = await getCities();
      setCities(['All', ...fetchedCities.data]);
    };

    const fetchRatings = async () => {
      // Simulate fetching cities from an API
      const fetchedRatings = await getRankingList();
      setRankings(['All', ...fetchedRatings.data.map(item => item.name)]);
    };

    void fetchCities();

    void fetchRatings();
  }, []);

  return (
    <div className={styles.settings}>
      <div className={styles.group}>
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={filterByGender}
            setValue={setFilterByGender}
            options={options}
            label="სქესი"
          />
        </div>

        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={filteredByCity}
            setValue={setFilteredByCity}
            options={cities}
            label="ქალაქი"
          />
        </div>

        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={filteredByRanking}
            setValue={setFilteredByRanking}
            options={rankings}
            label="რეიტინგი"
          />
        </div>

        <div className={styles.btns}>
          <button className={cn('button-stroke', styles.button)} onClick={reset}>
            გასუფთავება
          </button>
          <button className={cn('button', styles.button)} onClick={handleFilter}>
            გაფილტვრა
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
